import { getStoredPlayerName, setStoredPlayerName } from '../utils/playerName';

export class NameInputModal {
  private overlay: HTMLDivElement;
  private input: HTMLInputElement;
  private resolvePromise: ((name: string) => void) | null = null;
  private visible = false;

  constructor() {
    this.overlay = document.createElement('div');
    this.overlay.id = 'name-input-modal';
    this.overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.95);
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 2000;
      font-family: monospace;
      color: #fff;
    `;

    this.overlay.innerHTML = `
      <h1 style="font-size: 36px; margin-bottom: 10px; color: #ffd700;">NEW WORLD RECORD!</h1>
      <p style="font-size: 20px; margin-bottom: 30px; color: #aaa;">Enter your name for the leaderboard:</p>
      <input type="text" id="player-name-input" maxlength="20" style="
        font-size: 24px;
        font-family: monospace;
        padding: 10px 20px;
        width: 300px;
        text-align: center;
        background: #222;
        border: 2px solid #ffd700;
        color: #fff;
        outline: none;
      " />
      <p style="font-size: 16px; margin-top: 20px; color: #888;">Press Enter to submit</p>
    `;

    document.body.appendChild(this.overlay);
    this.input = this.overlay.querySelector('#player-name-input') as HTMLInputElement;

    this.input.addEventListener('keydown', (e) => {
      if (e.code === 'Enter' && this.resolvePromise) {
        const name = this.input.value.trim() || 'Anonymous';
        setStoredPlayerName(name);
        this.hide();
        this.resolvePromise(name);
        this.resolvePromise = null;
      }
      e.stopPropagation();
    });

    // Prevent other key events from bubbling
    this.overlay.addEventListener('keydown', (e) => e.stopPropagation());
    this.overlay.addEventListener('keyup', (e) => e.stopPropagation());
  }

  show(): Promise<string> {
    return new Promise((resolve) => {
      const storedName = getStoredPlayerName();

      // If player already has a saved name, use it without prompting
      if (storedName) {
        resolve(storedName);
        return;
      }

      // Otherwise, show the modal to get their name
      this.resolvePromise = resolve;
      this.input.value = '';
      this.overlay.style.display = 'flex';
      this.visible = true;
      this.input.focus();
    });
  }

  private hide(): void {
    this.overlay.style.display = 'none';
    this.visible = false;
  }

  isVisible(): boolean {
    return this.visible;
  }

  destroy(): void {
    this.overlay.remove();
  }
}
